import React from "react";
import { Form, FormControl } from "react-bootstrap";

/**
 * QuestionSection Component
 * Renders conditional question radio buttons
 * Memoized to prevent unnecessary re-renders
 * 
 * @param {Object} props
 * @param {string} props.question1 - First question value (yes/no)
 * @param {string} props.question2 - Second question text (conditional)
 * @param {Function} props.onChange - Change handler
 * @param {Object} props.formValidation - Validation error messages
 */
const QuestionSection = React.memo(({
  question1,
  question2,
  onChange,
  formValidation,
}) => {
  return (
    <>
      <Form.Group controlId="question1">
        <Form.Label>
          Have you received any Sales promotional Material ?
        </Form.Label>
        <div className="mt-2 d-flex mb-2">
          <div className="form-check me-5">
            <FormControl
              type="radio"
              name="question1"
              value="yes"
              checked={question1 === "yes"}
              onChange={onChange}
              id="question1Yes"
            />
            <label className="form-check-label" htmlFor="question1Yes">
              Yes
            </label>
          </div>
          <div className="form-check">
            <FormControl
              type="radio"
              name="question1"
              value="no"
              checked={question1 === "no"}
              onChange={onChange}
              id="question1No"
            />
            <label className="form-check-label" htmlFor="question1No">
              No
            </label>
          </div>
        </div>
        {formValidation.question1 && (
          <p className="text-danger">{formValidation.question1}</p>
        )}
      </Form.Group>

      {question1 === "yes" && (
        <Form.Group controlId="question2">
          <Form.Label>If yes then add remark</Form.Label>
          <FormControl
            type="text"
            name="question2"
            value={question2}
            placeholder="Enter Your Text"
            onChange={onChange}
          />
        </Form.Group>
      )}
    </>
  );
});

QuestionSection.displayName = "QuestionSection";

export default QuestionSection;
